import * as Sentry from '@sentry/react';

export const sendSentryLog = (data, message) => {
  try {
    if (Sentry) {
      Sentry.withScope((scope) => {
        scope.setLevel('log');
        if (Array.isArray(data)) {
          data.forEach((item) => {
            scope.addBreadcrumb(item);
          });
        } else {
          scope.addBreadcrumb({
            message: 'Log',
            data,
          });
        }
        Sentry.captureMessage(message);
      });
    }
  } catch (error) {
    console.error('Error sending log to Sentry', error);
  }
};

/**
 * Reporta un error del módulo MercadoPago a Sentry con contexto (tags y breadcrumbs).
 * No incluir datos sensibles (números de tarjeta, CVV, tokens).
 * @param {Error} error - Error capturado
 * @param {object} context - { feature, endpoint?, action?, step?, userId?, email?, paymentId?, amount? }
 */
export const captureMercadoPagoError = (error, context = {}) => {
  try {
    if (Sentry) {
      Sentry.withScope((scope) => {
        scope.setTag('module', 'mercadopago');
        if (context.feature) scope.setTag('feature', context.feature);
        if (context.endpoint) scope.setTag('endpoint', context.endpoint);
        if (context.action) scope.setTag('action', context.action);
        if (context.step) scope.setTag('step', String(context.step));
        if (context.userId) scope.setTag('mercadopago.userId', String(context.userId));
        if (context.paymentId) scope.setTag('mercadopago.paymentId', String(context.paymentId));
        const extraContext = {};
        if (context.userId != null) extraContext.userId = context.userId;
        if (context.email != null) extraContext.email = context.email;
        if (context.paymentId != null) extraContext.paymentId = context.paymentId;
        if (context.amount != null) extraContext.amount = context.amount;
        if (Object.keys(extraContext).length > 0) {
          scope.setContext('mercadopago', extraContext);
        }
        scope.addBreadcrumb({
          category: 'mercadopago',
          message: 'Context',
          data: context,
        });
        Sentry.captureException(error);
      });
    }
  } catch (e) {
    console.error('Error reporting to Sentry:', e);
  }
};
